import h from 'snabbdom/h';
import canvas from './canvas';
import styles from './styles';
import error from './error';
import manipulatorTools from './manipulatorTools';
import progress from './progress';
import { setPlayerElement, isFullscreen, setFullscreen,  shouldDisplayThumbnail } from '../modules/player';
import { isSceneLoaded, isSceneRendered, loadingProgress, numErrors } from '../modules/sceneIO';

const brokenThumbnails = {};

export default function player(store, { isFlex, isRelative, parentEl }) {
  const rendered = isSceneRendered(store);

  let sceneId = store.getIn(['sceneIO', 'id']);
  const hideThumbnail = rendered || !sceneId || !shouldDisplayThumbnail(store);

  const cssStyle = `
  div.claraplayer canvas {
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
  }
  div.claraplayer canvas:focus {
    outline: none;
  }
`;
  var children = [h('style', { props: { innerHTML: cssStyle } })];

  const fullscreenBackgroundColor = store.getIn(['player', 'fullscreenBackgroundColor']);
  const playerStyles =  Object.assign({}, styles.player, {
    backgroundImage: hideThumbnail ? '' : `url(${__URLROOT__}/api/scenes/${sceneId}/v2thumbnail)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
    backgroundPosition: 'center',
    position: (isFlex || isRelative) ? 'absolute' : 'relative',
    boxSizing: 'border-box',
    backgroundColor: isFullscreen(store) ?  fullscreenBackgroundColor : 'transparent',
    overflow: 'hidden',
  });

  if (numErrors(store)) {
    children.push(error(store));
  } else {
    children.push(canvas(store, 'player'));
    if (rendered) children.push(manipulatorTools(store));
    else children.push(progress(store));
  }

  return h('div.claraplayer', { style: playerStyles, hook: {
    insert: attachFullscreenHandlers(store),
  }, }, children);
}

function attachFullscreenHandlers(store) {
  return () => {
    [ // ['fullscreenChange', 'fullscreenElement'],
      ['webkitfullscreenchange', 'webkitIsFullScreen'],
      ['mozfullscreenchange', 'mozFullScreen'],
      ['MSFullscreenChange', 'msFullscreenElement'],
    ].forEach(function (info) {
      document.addEventListener(info[0], () => {
        //console.log('FULLSCREEN', info[0], !!document[info[1]]);
        store.dispatch(setFullscreen(!!document[info[1]]));
      });
    });
  };
}


/*function statsReporter() {
  var pageLoadTime, toRenderedTime;
  if (typeof performace === 'undefined') return function() {};

  return function(store, pct) {
    if (pageLoadTime && toRenderedTime) return;
    if (!pageLoadTime) pageLoadTime = new Date().getTime() - performance.timing.navigationStart;
    if (pct < 1) return;
    toRenderedTime = new Date().getTime() - performance.timing.navigationStart;
    console.log(`Page loaded in ${pageLoadTime}ms and rendered in ${toRenderedTime}ms`);
  };
};

//
//
var circleDiv = {
  flex: '0 0 25%'
};

var r = 90;
var PIR2 = Math.PI * r * 2;

var outer = {
  r, cx: 100, cy: 100,
  fill: 'transparent',
  'stroke-dasharray': PIR2,
  'stroke-dashoffset': 0,
  'stroke-width': '1em',
  stroke: '#eee'
};
var inner = {
  r, cx: 100, cy: 100,
  fill: 'transparent',
  stroke: colour,
  transition: 'stroke-dashoffset 1s linear',
  'stroke-width': '1em',
  'stroke-dashoffset': PIR2,
  'stroke-dasharray': PIR2
};
var svg = {
  height: '100%',
  width: '100%',
  viewport: '0 0 100 100',
  viewBox: '0 0 200 200',
};

function progress(store, pct) {
  var r = 90;
  var degrees = PIR2*(1-pct);

  return h('div', {style: {...styles.absoluteMaxCentered, backgroundColor: 'transparent', boxSizing: 'border-box' }}, [
    h('div', {style: circleDiv}, [
      h('svg', {attrs: svg}, [
        h('circle', {attrs: outer}),
        h('circle', {props: {id: 'bar'}, attrs: {...inner, 'stroke-dashoffset': degrees}}),
      ])
    ])
  ]);
};*/




// WEBPACK FOOTER //
// ./src/components/player.js